import { render, staticRenderFns } from "./VatRateProducts.vue?vue&type=template&id=d78741b2&"
import script from "./VatRateProducts.vue?vue&type=script&lang=ts&"
export * from "./VatRateProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports